import { getSyncStatus, postServiceOrderSync } from "../api/syncStatus";
import { ClientSyncRun, ServiceOrderSyncResult } from "../interfaces/SyncStatus";

/** Sync Status data layer (TAS-516). Mirrors dataLayer/employee.ts: log and rethrow, and
 *  leave the shaping to the manager above. */

const fetchSyncStatus = async (days?: number): Promise<ClientSyncRun[]> => {
  try {
    return await getSyncStatus(days);
  } catch (error) {
    console.error("Error in fetchSyncStatus:", error);
    throw error;
  }
};

const runServiceOrderSync = async (): Promise<ServiceOrderSyncResult> => {
  try {
    return await postServiceOrderSync();
  } catch (error) {
    console.error("Error in runServiceOrderSync:", error);
    throw error;
  }
};

export { fetchSyncStatus, runServiceOrderSync };
